import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from './components/firebase';
import LoginPage from './components/LoginPage';
import CancelOrderPage from './components/CancelOrderPage';
import DeliveredOrderPage from './components/DeliveredOrderPage';
import ReturnOrderPage from './components/ReturnOrderPage';
import ProductOrderPage from './components/ProductOrderPage';
import AdCostPage from './components/AdCostPage';
import LeadManagerPage from './components/LeadManagerPage';
import CallReportPage from './components/CallReportPage';
import WithoutOrdersPage from './components/WithoutOrdersPage';
import ResellerCrmPage from './components/ResellerCrmPage';
import ResellerDetailPage from './components/ResellerDetailPage';
import StoreCrmPage from './components/StoreCrmPage';
import StoreDetailPage from './components/StoreDetailPage';


function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-orange-400"></div>
      </div>
    );
  }

  return (
    <Router>
      <Routes>
        <Route
          path="/login"
          element={user ? <Navigate to="/cancel-order" /> : <LoginPage />}
        />
        <Route
          path="/cancel-order"
          element={user ? <CancelOrderPage /> : <Navigate to="/login" />}
        />
        <Route
          path="/"
          element={<Navigate to={user ? "/cancel-order" : "/login"} />}
        />

        <Route
          path="/delivered-order"
          element={user ? <DeliveredOrderPage /> : <Navigate to="/login" />}
        />

        <Route
          path="/returned-order"
          element={user ? <ReturnOrderPage /> : <Navigate to="/login" />}
        />

        <Route
          path="/create-order"
          element={user ? <ProductOrderPage /> : <Navigate to="/login" />}
        />

        <Route path="/ad-cost" element={user ? <AdCostPage /> : <Navigate to="/login" />} />

        <Route path="/lead-manager" element={user ? <LeadManagerPage /> : <Navigate to="/login" />} />

        <Route path="/call-report" element={user ? <CallReportPage /> : <Navigate to="/login" />} />

        <Route path="/without-orders" element={user ? <WithoutOrdersPage /> : <Navigate to="/login" />} />

        <Route path="/resellers" element={user ? <ResellerCrmPage /> : <Navigate to="/login" />} />

        <Route path="/reseller/:id" element={user ? <ResellerDetailPage /> : <Navigate to="/login" />} />

        <Route path="/stores" element={user ? <StoreCrmPage /> : <Navigate to="/login" />} />

        <Route path="/store/:id" element={user ? <StoreDetailPage /> : <Navigate to="/login" />} />

        {/* নতুন page: এখানে একটা <Route> যোগ করুন + DashboardNav.js এর NAV_SECTIONS এ item দিন */}

        {/* অজানা URL হলে হোম-এ পাঠিয়ে দেয় */}
        <Route path="*" element={<Navigate to="/" />} />

      </Routes>


    </Router>
  );
}

export default App;
